import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        try {
            const res = await api.get("/auth/me");
            setUser(res.data);
            return res.data;
        } catch (e) {
            setUser(null);
            return null;
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        // CRITICAL: skip /me check while returning from OAuth callback; AuthCallback handles it.
        if (window.location.hash?.includes("session_id=")) {
            setLoading(false);
            return;
        }
        refresh();
    }, [refresh]);

    const logout = async () => {
        try { await api.post("/auth/logout"); } catch (e) { console.error("Logout request failed:", e); }
        setUser(null);
        window.location.href = "/";
    };

    return (
        <AuthContext.Provider value={{ user, loading, refresh, logout, setUser }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
